import { useContext } from "react";

import { ErrorsContext } from "../context/Errors";

export const useErrorsContext = () => {
  const context = useContext(ErrorsContext);

  return context;
};
